import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import { AuthService } from '../../services/auth';
import { DeereFetch } from '../../shared/fetch';

export class CloseCaseDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loading : false
        }
        this.handleClickOpen=this.handleClickOpen.bind(this);
    }


    async handleClickOpen(){
        this.setState({open:true});

        try {
            const currentUser = await AuthService.user;
            const quote = await DeereFetch(`/api/quotes/${this.props.quote.id}/closecase`, {
                method: 'POST',
                query: {
                    userID: currentUser.id

                }
            });

            if (this.props.onclosecase){

                this.props.onclosecase(quote);
            }
        }catch(err){
            this.setState({open:false});
        } finally {
            this.setState({open:false});
        }

    }

  handleClose = () => {
      this.setState({open:false});

  };

  handleCloseWithLoading=()=>{
      this.setState({loading:true, open:false});

      setTimeout(()=>{
          this.setState({loading:false, open:false});
      }, 3000);
  }

  render() {

      return (
          <div>
              <Button color="primary" onClick={this.handleClickOpen} variant="outlined">Close Case</Button>

              <Dialog
                  aria-describedby="alert-dialog-description"
                  aria-labelledby="alert-dialog-title"
                  onClose={this.handleClose}
                  open={this.state.open}
              >
                  <DialogTitle id="alert-dialog-title">{'Saving data'}</DialogTitle>
                  <DialogContent align="center">
                      <Loader
                          color="#55a005"
                          height={100}
                          timeout={0}
                          type="Puff"
                          width={100} //3 secs

                      />
                  </DialogContent>
                  <DialogActions>

                  </DialogActions>
              </Dialog>
          </div>

      );
  }
}


